<template>
  <div class="parent-form">
    <div class="real-time-com">
      <RealTime />
    </div>
    <div class="header-btns">
      <HeaderBtn
        @Saqlash="Saqlash"
        @status="newStatus"
        @cancel="cancel"
        :sending="sending"
        :status="datas.status"
      />
    </div>
    <b-tabs
      active-nav-item-class="font-weight-bold text-light bg-success"
      style=" padding-top: 40px;"
    >
      <b-tab
        :title="$t('Регистрация')"
        @click="regClick"
        title-link-class="mr-1 text-primary font-weight-bold"
        style="padding: 0px !important;"
      >
        <div class="parent-bemor-form">
          <HeaderForm
            :summa="datas.summa"
            :user_name="user_name"
            :kelgan_kun="datas.created_at"
            :newBemor="selectedB"
            @bemorChange="bemorChange"
          />
        </div>
        <div class="parent-bemor-form" v-if="$route.name == 'Create'">
          <BemorForm
            @selectedBemor="selectedBemor"
            :bemor="bemor"
            :modalIdCom="1"
            @direct="direct"
          />
        </div>
        <!-- <div class="parent-bemor-form bemor-forma" style="display: flex;">
          <div>
            <label for="">Бўлим</label> <br />
            <v-select
              class="Tekshiruvchi-index-user"
              label="name"
              :options="bolim"
              v-model="datas.bolim"
              :reduce="option => option"
            />
          </div>
          <div class="ml-2">
            <label for="">Ордер рақами</label><br />
            <input
              :disabled="$store.state.bemor.imtiyoz_type == 'Imtiyozsiz'"
              class="bolim-input"
              type="number"
              v-model="datas.order_number"
            />
          </div>
          <div class="ml-2">
            <label for="">Бемор тиббий варақаси</label><br />
            <v-select
              class="Tekshiruvchi-index-user"
              label="name"
              :components="{ Deselect }"
              @input="change_history_type"
              :options="history_type"
              v-model="datas.history_type"
              :reduce="option => option.key"
            />
          </div>
        </div> -->
        <div class="parent-bemor-form" style="padding-bottom: 10px;">
          <TekshiruvForm
            @umumiySum="sumYigindi"
            :datas="datas"
            :sending="sending"
            :modalIdCom="0"
          />
        </div>
      </b-tab>
      <b-tab
        :title="$t('Бемор')"
        v-if="$route.name != 'ArxivOne'"
        @click="KasallikTarixi"
        title-link-class="mr-1 text-primary font-weight-bold"
        style="padding: 0px !important;"
      >
        <div class="parent-bemor-form">
          <BemorForm
            @selectedBemor="selectedBemor"
            :bemor="bemor"
            :direct_id="datas.direct_id"
            :modalIdCom="0"
            @direct="direct"
          />
        </div>
        <div class="parent-bemor-form">
          <KasallikTarixi :kasTarix="kasTarix" :modalIdCom="1" />
        </div>
      </b-tab>
    </b-tabs>
    <div
      class="notications xatoliklar alert-danger"
      style="z-index: 5"
      v-if="$store.state.errors != ''"
    >
      <button
        type="button"
        aria-hidden="true"
        class="close"
        @click="$store.state.errors = ''"
      >
        ×
      </button>
      <p>
        <i class="fas fa-exclamation-triangle"></i>&nbsp; {{ $t("Хатолик") }}
      </p>
      <div>{{ $store.state.errors }}</div>
    </div>
  </div>
</template>
<script>
import KasallikTarixi from "./Components/KasallikTarixi.vue";
// import HeaderBtns from "./Components/HeaderBtn.vue";
import TekshiruvForm from "./Components/Tekshiruvlar/TekBolim.vue";
import HeaderForm from "./Components/Header.vue";
import RealTime from "../../components/RealTime.vue";
import BemorForm from "./BemorForm.vue";
import HeaderBtn from "./Components/HeaderBtn.vue";
import axios from "axios";
export default {
  components: {
    RealTime,
    BemorForm,
    HeaderForm,
    TekshiruvForm,
    HeaderBtn,
    // HeaderBtns,
    KasallikTarixi
  },
  data() {
    return {
      sending: false,
      user_name: JSON.parse(localStorage.getItem("user")).user_name,
      selectedB: null,
      localUser: JSON.parse(localStorage.getItem("user")),
      history_type: [
        {key: 'default', name: 'Standard tibbiy karta'},
        {key: 'tuguruq', name: "Tug'uruq tibbiy karta"}
      ],
      Deselect: {
        render: createElement => createElement("span", "")
      },
      bolim: [],
      datas: {
        id: 0,
        created_at: null,
        user_id: JSON.parse(localStorage.getItem("user")).id,
        status: "waiting",
        patient_id: null,
        type_service: "Ambulator",
        direct_id: null,
        complaint: "",
        summa: 0,
        tramma_type: "Bir oydan ortiq",
        history_type: 'default',
        pay_summa: 0,
        backlog: 0,
        discount: 0,
        history_id: null,
        bolim_id: null,
        order_number: null,
        hospital_summa: 0,
        registration_doctor: [],
        registration_inspection: [],
        registration_palata: [],
        registration_pay: [],
        registration_files: [],
        surgery_registration: [],
        registration_uzi: [],
        reg_drug: false,
        registration_drug: [],
        reg_statsionar: {
          statsionar_text: ``,
          text: ``,
          xulosa: ``,
          asoslash: ``,
          kundalik: ``,
          reg_id: null,
          arrive_day: null,
          recede_day: null
        }
      },
      bemor: {
        id: null,
        fullname: "",
        name: "",
        lastname: "",
        patronymic: "",
        region_id: 12,
        region: {
          "id":12,
          "name":"Farg‘ona viloyati"
        },
        imtiyoz_type: "Imtiyozsiz",
        district_id: 165,
        district: 'Oltiariq tumani',
        phone: "",
        passport: "",
        addres: "",
        gender: "Ayol",
        citizen: false,
        percent: 0,
        birthday: ""
      },
      kasTarix: []
    };
  },
  methods: {
    direct(id) {
      this.datas.direct_id = id;
    },
    change_history_type(){
      this.datas.reg_statsionar.statsionar_text = ``
    },
    bemorChange(e) {
      if (e) {
        this.$store.state.bemor = e;
        this.datas.patient_id = e.id;
        this.bemor = e;
      } else {
        this.bemor = {
          id: null,
          fullname: "",
          name: "",
          lastname: "",
          patronymic: "",
          region_id: 2,
          region: null,
          imtiyoz_type: "Imtiyozsiz",
          district_id: null,
          district: null,
          phone: "",
          passport: "",
          addres: "",
          gender: "Ayol",
          citizen: false,
          percent: 0,
          birthday: ""
        };
        this.$store.state.bemor = {
          id: null,
          citizen: null,
          imtiyoz_type: "Imtiyozsiz",
          tramma_type: "Bir oydan ortiq"
        };
        this.datas.patient_id = null;
      }
    },
// Frontend: sumYigindi metodini quyidagicha yangilang
sumYigindi(item, type, v) {
  const amount = parseFloat(item) || 0;

  if (!v) {
    if (type) {
      this.datas.summa += amount;
      this.datas.backlog += amount;
    } else {
      this.datas.summa -= amount;
      this.datas.backlog -= amount;
    }
  } else if (v === "vazvrat") {
    if (type == "1") {
      this.datas.summa -= amount;
      this.datas.pay_summa -= amount;
    } else {
      this.datas.summa += amount;
      this.datas.pay_summa += amount;
    }
    // Qarzni qayta hisoblash
    this.datas.backlog = (this.datas.summa || 0) 
                       - (this.datas.pay_summa || 0) 
                       - (this.datas.discount || 0);
  }

  if (this.datas.backlog < 0) this.datas.backlog = 0;
  if (this.datas.summa < 0) this.datas.summa = 0;
  if (this.datas.pay_summa < 0) this.datas.pay_summa = 0;
},
    selectedBemor(data) {
      this.selectedB = data;
      this.datas.patient_id = data.id;
    },
    Saqlash() {
      let self = this;
      if (!self.sending) {
        self.datas.role = JSON.parse(localStorage.getItem("user")).role;
        self.sending = true;
        if (self.$route.name == "Create" && !self.$route.params.id) {
          axios({
            method: "post",
            url: "/registration/create",
            data: self.datas
          })
            .then(res => {
              if (res) {
                self.$router.go(-1);
                self.sending = false;
                self.$store.state.bemor = {};
              } else {
                self.sending = false;
              }
            })
            .catch(err => {
              if (err) {
                self.sending = false;
              }
            });
        } else if (self.$route.name == "Update") {
          axios({
            method: "patch",
            url: "/registration/update/" + self.$route.params.id,
            data: self.datas
          })
            .then(res => {
              if (res) {
                self.$router.go(-1);
                self.$store.state.bemor = {};
                self.sending = false;
              } else {
                self.sending = false;
              }
            })
            .catch(err => {
              if (err) {
                self.sending = false;
              }
            });
        }
      }
    },
    getReg() {
      let self = this;
      if (self.$route.name != "Create") {
        axios({
          method: "get",
          url: "/registration/one/" + self.$route.params.id
        }).then(res => {
          if (res) {
            self.selectedB = res.data.data.patient;
            self.bemor = res.data.data.patient;
            self.user_name = res.data.data.user.user_name;
            self.$store.state.bemor = res.data.data.patient;
            self.datas = res.data.data;
            self.datas.registration_drug = [];
            self.Complate();
          }
        });
      }
    },
    regClick() {
      this.$store.state.kasTar = false;
      this.$store.state.modalId = 0;
    },
    KasallikTarixi() {
      this.$store.state.kasTar = true;
      this.$store.state.modalId = 1;
      let s = this;
      axios({
        method: "get",
        url: "/registration/patient/" + s.datas.patient_id
      }).then(res => {
        if (res) {
          s.kasTarix = res.data;
        }
      });
    },
    cancel() {
      const x = window.confirm("Ростдан ҳам ойнани тарк этмоқчимисиз");
      if (x) {
        // this.$router.push("/user");
        if (this.$route.name == "Create" || this.$route.name == "Update") {
          this.$router.go(-1);
          this.$store.state.kasTar = false;
          this.$store.state.datas = {
            summa: 0,
            backlog: 0,
            discount: 0,
            pay_summa: 0,
            hospital_summa: 0
          };
          this.$store.state.bemor = {
            id: null,
            citizen: null,
            imtiyoz_type: "",
            tramma_type: "Bir oydan ortiq"
          };
        } else {
          window.close();
          this.$store.state.kasTar = false;
        }
      }
    },
    newStatus(val) {
      this.datas.status = val;
    },
    getBolim() {
      let self = this;
      axios({
        method: "get",
        url: "/bolim/all"
      }).then(res => {
        if (res) {
          self.bolim = res.data.data;
        }
      });
    },
    Complate() {
      if (this.$route.name == "Update") {
        this.datas.summa = 0;
        this.datas.pay_summa = 0;
        this.datas.backlog = 0;
        this.datas.discount = 0;
        if (this.datas.registration_inspection.length) {
          for (
            let index = 0;
            index < this.datas.registration_inspection.length;
            index++
          ) {
            const el = this.datas.registration_inspection[index];
            this.datas.summa += el.price;
            this.datas.pay_summa += el.pay_summa;
            this.datas.backlog += el.backlog;
            this.datas.discount += el.discount;
            el.deleted = false;
            el.update = false;
          }
        }
        if (this.datas.registration_doctor.length) {
          for (
            let index = 0;
            index < this.datas.registration_doctor.length;
            index++
          ) {
            const el = this.datas.registration_doctor[index];
            this.datas.summa += el.price;
            this.datas.pay_summa += el.pay_summa;
            this.datas.backlog += el.backlog;
            this.datas.discount += el.discount;
            el.deleted = false;
            el.update = false;
          }
        }
        if (this.datas.registration_palata.length) {
          for (
            let index = 0;
            index < this.datas.registration_palata.length;
            index++
          ) {
            const el = this.datas.registration_palata[index];
            this.datas.summa += el.price;
            this.datas.pay_summa += el.pay_summa;
            this.datas.backlog += el.backlog;
            this.datas.discount += el.discount;
          }
        }
        if (this.datas.surgery_registration.length) {
          for (
            let index = 0;
            index < this.datas.surgery_registration.length;
            index++
          ) {
            const el = this.datas.surgery_registration[index];
            this.datas.summa += el.price;
            this.datas.pay_summa += el.pay_summa;
            this.datas.backlog += el.backlog;
            this.datas.discount += el.discount;
            el.deleted = false;
            el.update = false;
            for (let i = 0; i < el.surgery_doctor.length; i++) {
              const element = el.surgery_doctor[i];
              this.datas.summa += element.price;
              this.datas.pay_summa += element.pay_summa;
              this.datas.backlog += element.backlog;
              this.datas.discount += element.discount;
              el.deleted = false;
              el.update = false;
            }
          }
        }
        // if (this.localUser.role == "Shifokor") {
        //   this.datas.registration_doctor.forEach(key => {
        //     if (key.doctor_id == this.localUser.doctor_id) {
        //       key.date_time = new Date()
        //         .valueOf()
        //         .toString()
        //         .slice(0, 10);
        //       key.status = "complate";
        //     }
        //   });
        // } else if (this.localUser.role == "Loborant") {
        //   this.datas.registration_inspection.forEach(key => {
        //     if (key.user_id == this.localUser.id) {
        //       key.date_time = new Date()
        //         .valueOf()
        //         .toString()
        //         .slice(0, 10);
        //       key.status = "complate";
        //     }
        //   });
        // }
      }
    }
  },
  mounted() {
    setInterval(() => {
      if (this.$store.state.errors != "") {
        this.$store.state.errors = "";
      }
    }, 5000);
    this.getReg();
    this.getBolim();
  }
};
</script>
<style>
.bolim-input {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 3px;
  width: 300px;
}
.kasallikT {
  pointer-events: none;
}
.navbarBtnTashxis-summa {
  padding: 2px 7px !important;
}
.parent-form {
  background: #d3e4e7;
  width: 100%;
  min-height: 100vh;
  max-width: 100%;
}
.parent-bemor-form {
  /* border: 1px solid #e4e5e6; */
  width: 98%;
  margin: 15px auto;
}
.real-time-com {
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 5;
}
.header-btns {
  position: sticky;
  top: 30px;
  z-index: 5;
  width: 100%;
  margin: 0 auto;
}
.xatoliklar {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  /* background: rgb(255, 0, 0); */
  padding: 5px 10px;
  border-radius: 10px;
  cursor: pointer;
  opacity: 0;
  animation: animateAlert 3s linear;
  pointer-events: all;
}
@keyframes animateAlert {
  0% {
    width: 0px;
    opacity: 0;
  }

  10% {
    width: 800px;
    opacity: 1;
  }

  90% {
    width: 800px;
    opacity: 1;
  }

  100% {
    width: 0px;
    opacity: 0;
  }
}
/* .header-form{

} */
</style>
